<template>
  <div>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="姓名" prop="legalPersonName" :class="checkNameChange('legalPersonName', formData.legalPersonName)? 'redItem' : null">
          <el-input v-model="formData.legalPersonName" maxlength="25" auto-complete="off"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="职务" prop="legalPersonDuty"
                      :class="checkNameChange('legalPersonDuty', formData.legalPersonDuty)? 'redItem' : null">
          <el-input v-model="formData.legalPersonDuty" auto-complete="off" maxlength="25"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="性别" prop="legalPersonSex" style="text-align: left"
                      :class="checkNameChange('legalPersonSex', formData.legalPersonSex)? 'redItem' : null">
          <el-radio-group v-model="formData.legalPersonSex">
            <el-radio label="男" :disabled="disabled"></el-radio>
            <el-radio label="女" :disabled="disabled"></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="身份证号码" prop="legalPersonIdcardNo"
                      :class="checkNameChange('legalPersonIdcardNo', formData.legalPersonIdcardNo)? 'redItem' : null">
          <el-input v-model="formData.legalPersonIdcardNo" auto-complete="off" maxlength="50"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="政治面貌" prop="legalPersonPoliticalStatus"
                      :class="checkNameChange('legalPersonPoliticalStatus', formData.legalPersonPoliticalStatus)? 'redItem' : null">
          <el-input v-model="formData.legalPersonPoliticalStatus" auto-complete="off" maxlength="5"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="联系电话" prop="legalPersonOfficeTel"
                      :class="checkNameChange('legalPersonOfficeTel', formData.legalPersonOfficeTel)? 'redItem' : null">
          <el-input v-model="formData.legalPersonOfficeTel" auto-complete="off" maxlength="15"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="手机号" prop="legalPersonMobile"
                      :class="checkNameChange('legalPersonMobile', formData.legalPersonMobile)? 'redItem' : null">
          <el-input v-model="formData.legalPersonMobile" auto-complete="off" maxlength="15"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "LegalPerson",
    data() {
      return {};
    },
    props: ["formData", "disabled"],
    methods: {
      checkNameChange(fieldName, value) {
        let flag = false
        if (this.formData.oldContent) {
          for (let key in this.formData.oldContent) {
            if (key == fieldName && value != this.formData.oldContent[key]) {
              flag = true
              break // break跳出循环
            }
          }
        }
        return flag
      },
    }
  }
</script>

<style scoped lang="less">
  .redItem /deep/ .el-form-item__label{
    color: red !important;
  }

  .redItem /deep/ .el-input__inner{
    color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Member/LegalPerson.vue